import React from "react";
import { Link } from "react-router-dom";
export function Logo({
  light = false
}: {
  light?: boolean;
}) {
  return <Link to="/" className="group flex flex-col leading-none focus:outline-none focus-visible:ring-2 focus-visible:ring-terracotta focus-visible:ring-offset-4 rounded-sm" aria-label="Domaine de la Rouquette — accueil" data-id="element-289" data-mp="8u4ralcbprnc">
      <span className={`font-display text-[1.45rem] font-medium tracking-tight whitespace-nowrap ${light ? "text-paper" : "text-ink"}`} data-id="element-290" data-mp="3v6bgpkx4hw79">
        Domaine de la Rouquette
      </span>
      <span className={`mt-1 text-[0.68rem] whitespace-nowrap ${light ? "text-paper/75" : "text-stone"}`} data-id="element-291" data-mp="ds69l41xdmxr">
        Ingrédients cosmétiques · Provence
      </span>
    </Link>;
}